

























require('axios')
import { Component, Prop, Vue } from 'vue-property-decorator';
import NewApi, { BasePath } from '../ts/api';
import { DefaultApi, Image, Credentials } from '../api';
import Gallery from './Gallery.vue';

let api: DefaultApi;

@Component(
  {
    components:{
Gallery,
    }
  }
)
export default class About extends Vue {
  credentials = {} as Credentials;
  imgs = [] as Image[];
  
  mounted(){
    api = NewApi()
  }


}
